module.exports = __webpack_public_path__ + "static/media/Matteo Zallio.dc52a18c.png";